import VueRouter from "vue-router";
import { routes } from "../routes";
var router = new VueRouter({
    mode: 'history',
    routes: routes,
});
export { router, VueRouter };
